// extracted by mini-css-extract-plugin
export var activeDot = "_5j-c";
export var buttonContainer = "_5j-9";
export var channelButton = "_5j-a";
export var clickable = "_5j-d";
export var content = "_5j-0";
export var contentFull = "_5j-2";
export var contentThird = "_5j-1";
export var contentWrapper = "_5j-7";
export var description = "_5j-5";
export var heightShort = "_5j-f";
export var image = "_5j-3";
export var imageContainer = "_5j-4";
export var selectButton = "_5j-e";
export var spinnerContainer = "_5j-b";
export var titleContent = "_5j-8";
export var titleWrapper = "_5j-6";